export const API_BASE_URL = 'https://api.marsool.aryabyte.com'
// export const API_BASE_URL = 'http://45.248.33.161:5010' // staging
// export const API_BASE_URL = 'http://192.168.29.34:3000' //local

export const MEDIA_URL = 'https://minio.techreale.com/marsool/'
export const ApiEndPoints = {
  AUTH: {
    login: `${API_BASE_URL}/api/v1/admin/auth/login`,
    me: `${API_BASE_URL}/api/v1/admin/auth/me`,
    forgot: `${API_BASE_URL}/api/v1/admin/auth/forgot/password`,
    verifyotp: `${API_BASE_URL}/api/v1/admin/auth/verify/otp`,
    reset: `${API_BASE_URL}/api/v1/admin/auth/reset/password`
  },
  DASHBOARD: {
    count: `${API_BASE_URL}/api/v1/admin/dashboard`
  },
  USERS: {
    list: `${API_BASE_URL}/api/v1/admin/users/list`,
    listCounts: `${API_BASE_URL}/api/v1/admin/users/counts`,
    listforemailcampaign: `${API_BASE_URL}/api/v1/admin/users/list-for-email-campaign`,
    create: `${API_BASE_URL}/api/v1/admin/users`,
    edit: id => `${API_BASE_URL}/api/v1/admin/users/change-status/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/users/${id}`,
    listById: id => `${API_BASE_URL}/api/v1/admin/users/${id}`,
    zoneList: `${API_BASE_URL}/api/v1/admin/users/get-zone-list`,
    AREA_FROM_ZONE: {
      list: id => `${API_BASE_URL}/api/v1/admin/cities/area-from-zone/${id}`
    },
    export: `${API_BASE_URL}/api/v1/admin/users/export`,
    driver: `${API_BASE_URL}/api/v1/admin/users/fetch-all-driver`,
    changePassword: `${API_BASE_URL}/api/v1/auth/admin/change-password`,
    userTransactionHistory: id => `${API_BASE_URL}/api/v1/admin/users/${id}/transactions`
  },

  NOTIFICATION: {
    list: `${API_BASE_URL}/api/v1/admin/notification`,
    markAllAsRead: `${API_BASE_URL}/api/v1/admin/notification/mark-all-admin-read`
  },
  PRIVACY_POLICY: {
    list: `${API_BASE_URL}/api/v1/admin/legalcontent/privacy_policy`,
    edit: `${API_BASE_URL}/api/v1/admin/legalcontent/privacy_policy`
  },
  Terms_AND_CONDITIONS: {
    list: `${API_BASE_URL}/api/v1/admin/legalcontent/terms_and_conditions`,
    list: `${API_BASE_URL}/api/v1/admin/legalcontent/terms_and_conditions`,
    edit: `${API_BASE_URL}/api/v1/admin/legalcontent/terms_and_conditions`
  },
  Testimonials: {
    list: `${API_BASE_URL}/api/v1/admin/testimonials`,
    create: `${API_BASE_URL}/api/v1/admin/testimonials`,
    edit: id => `${API_BASE_URL}/api/v1/admin/testimonials/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/testimonials/${id}`
  },
  FAQ: {
    list: `${API_BASE_URL}/api/v1/admin/faqs`,
    create: `${API_BASE_URL}/api/v1/admin/faqs`,
    edit: id => `${API_BASE_URL}/api/v1/admin/faqs/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/faqs/${id}`
  },
  BLOG: {
    list: `${API_BASE_URL}/api/v1/admin/blogs`,
    create: `${API_BASE_URL}/api/v1/admin/blogs`,
    edit: id => `${API_BASE_URL}/api/v1/admin/blogs/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/blogs/${id}`
  },
  OUR_TEAM: {
    list: `${API_BASE_URL}/api/v1/admin/ourteam`,
    create: `${API_BASE_URL}/api/v1/admin/ourteam`,
    edit: id => `${API_BASE_URL}/api/v1/admin/ourteam/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/ourteam/${id}`
  },
  ContactUs: {
    list: `${API_BASE_URL}/api/v1/admin/contactus`,
    reply: id => `${API_BASE_URL}/api/v1/admin/contactus/${id}`
  },
  GET_REGION: {
    // country: `https://api.countrystatecity.in/v1/countries`,
    // state: `https://api.countrystatecity.in/v1/countries/`,
    // city: `https://api.countrystatecity.in/v1/countries/`
    country: `${API_BASE_URL}/api/v1/common/dropdown/countries-data`,
    state: `${API_BASE_URL}/api/v1/common/dropdown/states-from-country`,
    city: `${API_BASE_URL}/api/v1/common/dropdown/cities-from-state`
  },

  //for getting currency of country
  COUNTRY: {
    list: `${API_BASE_URL}/api/v1/admin/cities/countries`
  },

  CITY_MANAGEMENT: {
    list: `${API_BASE_URL}/api/v1/admin/cities`,
    create: `${API_BASE_URL}/api/v1/admin/cities`,
    edit: id => `${API_BASE_URL}/api/v1/admin/cities/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/cities/${id}`
  },
  PRODUCT_CATEGORY: {
    list: `${API_BASE_URL}/api/v1/admin/products-category`,
    create: `${API_BASE_URL}/api/v1/admin/products-category`,
    edit: id => `${API_BASE_URL}/api/v1/admin/products-category/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/products-category/${id}`
  },
  PRODUCT_PACKAGING: {
    list: `${API_BASE_URL}/api/v1/admin/products-packaging`,
    create: `${API_BASE_URL}/api/v1/admin/products-packaging`,
    edit: id => `${API_BASE_URL}/api/v1/admin/products-packaging/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/products-packaging/${id}`
  },
  COUPONS: {
    list: `${API_BASE_URL}/api/v1/admin/coupon`,
    create: `${API_BASE_URL}/api/v1/admin/coupon`,
    edit: id => `${API_BASE_URL}/api/v1/admin/coupon/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/coupon/${id}`,
    couponDetailsList: `${API_BASE_URL}/api/v1/admin/coupon/with-orders`
  },
  REFERRAL_CODE: {
    list: `${API_BASE_URL}/api/v1/admin/referral-code`,
    edit: id => `${API_BASE_URL}/api/v1/admin/referral-code/${id}`,
    transactions: `${API_BASE_URL}/api/v1/admin/referral-code/transactions`
  },
  ORDER_SERVICE: {
    list: `${API_BASE_URL}/api/v1/admin/order-service`,
    create: `${API_BASE_URL}/api/v1/admin/order-service`,
    edit: id => `${API_BASE_URL}/api/v1/admin/order-service/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/order-service/${id}`
  },
  ORDER_STATUS: {
    list: `${API_BASE_URL}/api/v1/admin/order`,
    edit: id => `${API_BASE_URL}/api/v1/admin/order/change-sub-status/${id}`,
    listById: id => `${API_BASE_URL}/api/v1/admin/order/${id}`,
    ORDER_HISTORY: {
      list: `${API_BASE_URL}/api/v1/common/admin-order-history`
    }
  },
  CASHOUT_REQUEST: {
    list: `${API_BASE_URL}/api/v1/admin/cashout`,
    edit: id => `${API_BASE_URL}/api/v1/admin/cashout/${id}`,
    financialOfficier: `${API_BASE_URL}/api/v1/admin/cashout/financial-officers`
  },
  INVENTORY_PACKAGE: {
    list: `${API_BASE_URL}/api/v1/admin/inventory-package`,
    create: `${API_BASE_URL}/api/v1/admin/inventory-package`,
    edit: id => `${API_BASE_URL}/api/v1/admin/inventory-package/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/inventory-package/${id}`
  },
  INVENTORY_PACKAGE_REQUEST: {
    list: `${API_BASE_URL}/api/v1/admin/inventory-package-request`,
    edit: id => `${API_BASE_URL}/api/v1/admin/inventory-package-request/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/inventory-package-request/${id}`
  },
  PRODUCT_INVENTORY_REQUEST: {
    list: `${API_BASE_URL}/api/v1/admin/product-inventory-request`,
    edit: id => `${API_BASE_URL}/api/v1/admin/product-inventory-request/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/product-inventory-request/${id}`,
    STORAGE_UNIT_LIST: {
      list: `${API_BASE_URL}/api/v1/admin/product-inventory-request/storage-unit`
    }
  },
  ZONE: {
    list: `${API_BASE_URL}/api/v1/admin/zone`,
    create: `${API_BASE_URL}/api/v1/admin/zone`,
    edit: id => `${API_BASE_URL}/api/v1/admin/zone/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/zone/${id}`,
    zoneList: `${API_BASE_URL}/api/v1/admin/cities/zone`,
    cityZone: `${API_BASE_URL}/api/v1/admin/cities/city-wise-zone`
  },
  HQ_ADDRESS: {
    list: `${API_BASE_URL}/api/v1/admin/hq-address`,
    create: `${API_BASE_URL}/api/v1/admin/hq-address`,
    edit: id => `${API_BASE_URL}/api/v1/admin/hq-address/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/hq-address/${id}`,
    AREA_FROM_ZONE: {
      list: `${API_BASE_URL}/api/v1/admin/cities/area-from-zone`
    }
  },
  PACKAGE_DIMENSION: {
    list: `${API_BASE_URL}/api/v1/admin/package-dimention`,
    create: `${API_BASE_URL}/api/v1/admin/package-dimention`,
    edit: id => `${API_BASE_URL}/api/v1/admin/package-dimention/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/package-dimention/${id}`
  },
  PACKAGE_WEIGHT: {
    list: `${API_BASE_URL}/api/v1/admin/package-weight`,
    create: `${API_BASE_URL}/api/v1/admin/package-weight`,
    edit: id => `${API_BASE_URL}/api/v1/admin/package-weight/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/package-weight/${id}`
  },
  PACKAGE_OPENED_CHARGES: {
    list: `${API_BASE_URL}/api/v1/admin/package-open-charges`,
    create: `${API_BASE_URL}/api/v1/admin/package-open-charges`,
    edit: id => `${API_BASE_URL}/api/v1/admin/package-open-charges/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/package-open-charges/${id}`
  },
  LOG_ISSUE: {
    LOG_ISSUES: {
      list: `${API_BASE_URL}/api/v1/admin/log-issue`,
      create: `${API_BASE_URL}/api/v1/admin/log-issue/create`,
      updateEscalationStatus: `${API_BASE_URL}/api/v1/admin/log-issue/update-escalation-status`,
      mainReason: `${API_BASE_URL}/api/v1/admin/log-issue/main-reasons-all`,
      subReason: `${API_BASE_URL}/api/v1/admin/log-issue/sub-reasons-all`,
      checkValidOrderId: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/validate-order-qr`
    },
    MAIN_REASONS: {
      list: `${API_BASE_URL}/api/v1/admin/log-issue/main-reasons`,
      create: `${API_BASE_URL}/api/v1/admin/log-issue/main-reason`,
      edit: id => `${API_BASE_URL}/api/v1/admin/log-issue/main-reason/${id}`,
      delete: id => `${API_BASE_URL}/api/v1/admin/log-issue/main-reason/${id}`
    },
    SUB_REASONS: {
      list: id => `${API_BASE_URL}/api/v1/admin/log-issue/sub-reason-by-main-reason/${id}`,
      create: `${API_BASE_URL}/api/v1/admin/log-issue/sub-reason`,
      edit: id => `${API_BASE_URL}/api/v1/admin/log-issue/sub-reason/${id}`,
      delete: id => `${API_BASE_URL}/api/v1/admin/log-issue/sub-reason/${id}`
    }
  },
  COMMISSION_AMOUNT: {
    list: `${API_BASE_URL}/api/v1/admin/commission-amount`,
    create: `${API_BASE_URL}/api/v1/admin/commission-amount`,
    edit: id => `${API_BASE_URL}/api/v1/admin/commission-amount/${id}`
  },
  BILLIND_AND_PAYMENT: {
    list: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing`,
    create: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing`,
    edit: id => `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/${id}`
  },
  PERMISSIONS: {
    permissions: `${API_BASE_URL}/api/v1/admin/permission/view-all`,
    list: `${API_BASE_URL}/api/v1/admin/permission`,
    create: `${API_BASE_URL}/api/v1/admin/permission`,
    edit: id => `${API_BASE_URL}/api/v1/admin/permission/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/permission/${id}`
  },
  ROLES: {
    roles: `${API_BASE_URL}/api/v1/admin/role/view-all`,
    list: `${API_BASE_URL}/api/v1/admin/role`,
    create: `${API_BASE_URL}/api/v1/admin/role`,
    edit: id => `${API_BASE_URL}/api/v1/admin/role/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/role/${id}`
  },
  SUB_ADMIN: {
    list: `${API_BASE_URL}/api/v1/admin/sub-admin`,
    create: `${API_BASE_URL}/api/v1/admin/sub-admin`,
    edit: id => `${API_BASE_URL}/api/v1/admin/sub-admin/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/sub-admin/${id}`
  },
  GLOBAL_FEES: {
    list: `${API_BASE_URL}/api/v1/admin/global-fees`,
    create: `${API_BASE_URL}/api/v1/admin/global-fees`,
    edit: id => `${API_BASE_URL}/api/v1/admin/global-fees/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/global-fees/${id}`
  },
  RATINGS: {
    list: `${API_BASE_URL}/api/v1/admin/rating`
  },
  BILLING_PAYMENT_MANAGEMENT: {
    list: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/billing-and-payment`,
    create: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/billing-and-payment`,
    // edit: id => `${API_BASE_URL}/api/v1/admin/billing-invoice/${id}`,
    edit: id => `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/billing-and-payment/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/billing-invoice/${id}`,
    userList: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/user-list`,
    billingUserList: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/get-financial-officer`,
    getOrderId: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/verify-order`,
    serviceList: `${API_BASE_URL}/api/v1/admin/billing-invoice-payment-processing/service`
  },
  CAMPAIGN_NOTIFICATION: {
    list: `${API_BASE_URL}/api/v1/admin/notification/campaing-notification`,
    create: `${API_BASE_URL}/api/v1/admin/notification/campaing-notification`,
    EMAIL_CAMPAIGN: {
      list: `${API_BASE_URL}/api/v1/admin/email-campaign`,
      create: `${API_BASE_URL}/api/v1/admin/email-campaign`,
      edit: id => `${API_BASE_URL}/api/v1/admin/email-campaign/${id}`
    }
  },
  EMAIL_CAMPAIGN: {
    list: `${API_BASE_URL}/api/v1/admin/email-campaign`,
    create: `${API_BASE_URL}/api/v1/admin/email-campaign`,
    edit: id => `${API_BASE_URL}/api/v1/admin/email-campaign/${id}`
  },
  SMS_ALERT: {
    list: `${API_BASE_URL}/api/v1/admin/sms-campaign`,
    create: `${API_BASE_URL}/api/v1/admin/sms-campaign`
  },
  STORAGE_UNITS: {
    list: `${API_BASE_URL}/api/v1/admin/storage-unit`,
    create: `${API_BASE_URL}/api/v1/admin/storage-unit`,
    edit: id => `${API_BASE_URL}/api/v1/admin/storage-unit/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/admin/storage-unit/${id}`
  }
}
